<template>
  <svg
    width="58"
    height="58"
    viewBox="0 0 58 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      :class="active ? 'a-active' : 'a'"
      cx="29"
      cy="29"
      r="28.5"
      stroke="#142B6F"
    />
    <path
      :class="active ? 'a-active' : 'a'"
      d="M22.0254 15C22.0254 14.7239 21.8015 14.5 21.5254 14.5C21.2492 14.5 21.0254 14.7239 21.0254 15L22.0254 15ZM29.4079 28.663L29.2284 29.1297L29.4079 28.663ZM36.7904 42.3261C36.7904 42.6022 37.0143 42.8261 37.2904 42.8261C37.5666 42.8261 37.7904 42.6022 37.7904 42.3261H36.7904ZM21.0254 15C21.0254 17.6193 21.0862 20.4004 22.1496 22.8991C23.2276 25.432 25.3097 27.6225 29.2284 29.1297L29.5874 28.1964C25.8875 26.7733 24.0283 24.7598 23.0697 22.5075C22.0966 20.221 22.0254 17.6357 22.0254 15L21.0254 15ZM29.2284 29.1297C32.5485 30.4066 34.4097 32.1685 35.4613 34.3336C36.5256 36.525 36.7904 39.1869 36.7904 42.3261H37.7904C37.7904 39.1593 37.5298 36.3034 36.3608 33.8967C35.179 31.4636 33.0989 29.547 29.5874 28.1964L29.2284 29.1297Z"
      fill="#142B6F"
    />
    <path
      :class="active ? 'a-active' : 'a'"
      d="M36.2656 15C36.2656 14.7239 36.4895 14.5 36.7656 14.5C37.0418 14.5 37.2656 14.7239 37.2656 15L36.2656 15ZM28.8831 28.663L29.0626 29.1297L28.8831 28.663ZM21.5006 42.3261C21.5006 42.6022 21.2767 42.8261 21.0006 42.8261C20.7244 42.8261 20.5006 42.6022 20.5006 42.3261H21.5006ZM37.2656 15C37.2656 17.6193 37.2049 20.4004 36.1414 22.8991C35.0634 25.432 32.9813 27.6225 29.0626 29.1297L28.7036 28.1964C32.4035 26.7733 34.2627 24.7598 35.2213 22.5075C36.1944 20.221 36.2656 17.6357 36.2656 15L37.2656 15ZM29.0626 29.1297C25.7426 30.4066 23.8814 32.1685 22.8298 34.3336C21.7654 36.525 21.5006 39.1869 21.5006 42.3261H20.5006C20.5006 39.1593 20.7613 36.3034 21.9303 33.8967C23.112 31.4636 25.1921 29.547 28.7036 28.1964L29.0626 29.1297Z"
      fill="#142B6F"
    />
    <line
      :class="active ? 'a-active' : 'a'"
      x1="21.5"
      y1="17.6528"
      x2="33.112"
      y2="17.6528"
      stroke="#142B6F"
      stroke-linecap="round"
    />
    <line
      :class="active ? 'a-active' : 'a'"
      x1="0.5"
      y1="-0.5"
      x2="12.112"
      y2="-0.5"
      transform="matrix(-1 0 0 1 36.7656 36.02)"
      stroke="#142B6F"
      stroke-linecap="round"
    />
    <line
      :class="active ? 'a-active' : 'a'"
      x1="22.5518"
      y1="21.8569"
      x2="29.9598"
      y2="21.8569"
      stroke="#142B6F"
      stroke-linecap="round"
    />
    <line
      :class="active ? 'a-active' : 'a'"
      x1="0.5"
      y1="-0.5"
      x2="7.90803"
      y2="-0.5"
      transform="matrix(-1 0 0 1 37.8154 40.2241)"
      stroke="#142B6F"
      stroke-linecap="round"
    />
  </svg>

</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.a {
  stroke: #CDD1DE;
  stroke-width: 1px;
}

.a-active {
}
</style>
